import axios from "axios";
import React, { useEffect, useState, useRef } from "react";
import BaseUrl from "../../Components/BaseUrl";
import Cookies from "js-cookie";
import {useNavigate } from "react-router-dom";
import swal from "sweetalert2";
import {
  MdThumbUp,
  MdReply,
  MdKeyboardArrowUp,
  MdKeyboardArrowDown,
} from "react-icons/md";
import "yet-another-react-lightbox/styles.css";
import {
  FaRegShareSquare,
  FaBookmark,
  FaRegBookmark,
} from "react-icons/fa";
import { PiDotsThree } from "react-icons/pi";
import EmojiPicker from "emoji-picker-react";
const PostFeed = ({ postData, CurrentUser }) => {
  const [currentUser, setCurrentUser] = useState(CurrentUser);
  const [isLoading, setIsLoading] = useState(false);
  const [post, setPost] = useState(postData); // Single post object
  const [likes, setLikes] = useState(postData.likes || 0);
  const [hasLiked, setHasLiked] = useState(postData.has_liked || false);
  const [commentLikes, setCommentLikes] = useState({});
  const [commentLikedPosts, setCommentLikedPosts] = useState({});
  const [comments, setComments] = useState(postData.comments || []);
  const [showComments, setShowComments] = useState(false);
  const [newComment, setNewComment] = useState("");

    const [imageModalData, setImageModalData] = useState(null);
    const [currentImageIndex, setCurrentImageIndex] = useState(0);


  const [replyingTo, setReplyingTo] = useState(null);
  const [showOptions, setShowOptions] = useState(false);
  const optionsRef = useRef(null);
  const buttonRef = useRef(null);
  const [replyText, setReplyText] = useState("");
  const [isSaved, setIsSaved] = useState(postData.is_saved || false);
  const [showAllComments, setShowAllComments] = useState(false);
  const [showAllReplies, setShowAllReplies] = useState({});
  const navigate = useNavigate();
  const [showReplyEmojiPicker, setShowReplyEmojiPicker] = useState(null);
  const [showEmojiPicker, setShowEmojiPicker] = useState(false);
  const commentInputRef = useRef(null);
  const replyInputRefs = useRef({});
  const EmojiPickerWrapper = ({ onEmojiSelect, onClose, positionClass, inputRef }) => {
    const pickerRef = useRef(null);

    useEffect(() => {
      const handleClickOutside = (e) => {
        if (pickerRef.current && !pickerRef.current.contains(e.target)) {
          onClose();
        }
      };
      document.addEventListener("mousedown", handleClickOutside);
      return () =>
        document.removeEventListener("mousedown", handleClickOutside);
    }, [onClose]);

    return (
      <div ref={pickerRef} className={`absolute z-50 ${positionClass}`}>
        <EmojiPicker
          onEmojiClick={(emojiData) => {
            onEmojiSelect(emojiData.emoji);
            onClose();
            if (inputRef && inputRef.current) {
              inputRef.current.focus();
            }
          }}
          width={300}
          height={350}
        />
      </div>
    );
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        showOptions &&
        optionsRef.current &&
        !optionsRef.current?.contains(event.target) &&
        !buttonRef.current?.contains(event.target)
      ) {
        setShowOptions(false);
      }
    };
    if (showOptions) {
      document.addEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showOptions]);

  const handleToggleSave = async () => {
    try {
      const response = await axios.post(
        `${BaseUrl}unsavepost`,
        {
          saved_type: "post",
          savable_id: post.id,
        },
        {
          headers: {
            Authorization: `Bearer ${Cookies.get("token")}`,
            Accept: "application/json",
          },
        }
      );
      if (response.data.status === 200) {
        setIsSaved(!isSaved);
        setShowOptions(false);
        navigate("/my-items/saved-post");
      }
    } catch (error) {
      setShowOptions(false);
      console.error("Error toggling save:", error);
      swal.fire({
        icon: "error",
        title: "Error",
        text: "Failed to update save status",
      });
    }
  };

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString("en-US", {
      month: "short",
      day: "numeric",
    });
  };

  const formatTimeAgo = (dateString) => {
    const date = new Date(dateString);
    const now = new Date();
    const diffInSeconds = Math.floor((now - date) / 1000);

    if (diffInSeconds < 60) return "Just now";
    if (diffInSeconds < 3600) return `${Math.floor(diffInSeconds / 60)}m ago`;
    if (diffInSeconds < 86400)
      return `${Math.floor(diffInSeconds / 3600)}h ago`;
    return `${Math.floor(diffInSeconds / 86400)}d ago`;
  };

  const handleLike = async () => {
    try {
      const prevLiked = hasLiked;
      const prevLikes = likes;

      setHasLiked(!prevLiked);
      setLikes(prevLiked ? prevLikes - 1 : prevLikes + 1);

      const endpoint = prevLiked
        ? `unlikepost/${post.id}`
        : `likepost/${post.id}`;
      await axios.post(
        BaseUrl + endpoint,
        {},
        {
          headers: {
            Authorization: `Bearer ${Cookies.get("token")}`,
            Accept: "application/json",
          },
        }
      );
    } catch (error) {
      console.error("Error updating like:", error);
      setHasLiked(prevLiked);
      setLikes(prevLikes);
      swal.fire({
        icon: "error",
        title: "Error",
        text: "Failed to update like status",
      });
    }
  };

  const handleCommentLike = async (isCurrentlyLiked, commentId) => {
    try {
      setCommentLikedPosts((prev) => ({
        ...prev,
        [commentId]: !prev[commentId],
      }));
      setCommentLikes((prev) => ({
        ...prev,
        [commentId]: isCurrentlyLiked
          ? prev[commentId] - 1
          : prev[commentId] + 1,
      }));

      const endpoint = isCurrentlyLiked
        ? `unlikecomment/${commentId}`
        : `likecomment/${commentId}`;
      const response = await axios.post(
        BaseUrl + endpoint,
        {},
        {
          headers: {
            Authorization: `Bearer ${Cookies.get("token")}`,
            Accept: "application/json",
          },
        }
      );

      if (response.status === 200) {
        const updatedComments = comments.map((comment) =>
          comment.comment_id === commentId
            ? {
                ...comment,
                comment_likes: isCurrentlyLiked
                  ? comment.comment_likes - 1
                  : comment.comment_likes + 1,
                has_liked_comment: !isCurrentlyLiked,
              }
            : comment
        );
        setComments(updatedComments);
      }
    } catch (error) {
      console.error("Error updating comment like:", error);
      setCommentLikedPosts((prev) => ({
        ...prev,
        [commentId]: isCurrentlyLiked,
      }));
      setCommentLikes((prev) => ({
        ...prev,
        [commentId]: isCurrentlyLiked
          ? prev[commentId] + 1
          : prev[commentId] - 1,
      }));
    }
  };

  const handleShowComments = () => {
    setShowComments(!showComments);
  };

  const handleCommentSubmit = async (e) => {
    e.preventDefault();
    if (!newComment.trim()) return;

    // Create temporary comment
    const tempComment = {
      comment_id: `temp-${Math.random().toString(36).substr(2, 9)}`, // Unique temp ID
      comment: newComment.trim(),
      comment_user_name: CurrentUser.name,
      comment_user_profile: CurrentUser.profile_image,
      created_at: new Date().toISOString(),
      comment_likes: 0,
      has_liked_comment: false,
      replies: [],
      isTemporary: true, 
    };


    setComments((prev) => [ tempComment, ...prev]);
    setNewComment(""); 

  
    const formData = new FormData();
    formData.append("comment", newComment.trim());

    try {
      const response = await axios.post(BaseUrl + `comment/${post.id}`, formData, {
        headers: {
          Authorization: `Bearer ${Cookies.get("token")}`,
          Accept: "application/json",
        },
      });

      if (response.data.status === 200) {
        
        const serverComment = response.data.data;
        setComments((prev) =>
          prev.map((comment) =>
            comment.comment_id === tempComment.comment_id
              ? {
                  ...serverComment,
                  comment_user_name: CurrentUser.name, 
                  comment_user_profile: CurrentUser.profile_image,
                }
              : comment
          )
        );
      } else {
        // Remove temporary comment on failure
        setComments((prev) =>
          prev.filter((comment) => comment.comment_id !== tempComment.comment_id)
        );
        swal.fire({
          icon: "error",
          title: "Error",
          text: "Failed to post comment",
        });
      }
    } catch (error) {
      console.error("Error submitting comment:", error);
      // Remove temporary comment on error
      setComments((prev) =>
        prev.filter((comment) => comment.comment_id !== tempComment.comment_id)
      );
      swal.fire({
        icon: "error",
        title: "Error",
        text: "Failed to post comment",
      });
    }
  };

  const handleReplySubmit = async (e, commentId) => {
    e.preventDefault();
    if (!replyText.trim()) return;

    const formData = new FormData();
    formData.append("comment", replyText.trim());

    try {
      const response = await axios.post(
        BaseUrl + `commentreply/${post.id}/${commentId}`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${Cookies.get("token")}`,
            Accept: "application/json",
          },
        }
      );
      if (response.data.status === 200) {
        const updatedComments = comments.map((comment) =>
          comment.comment_id === commentId
            ? {
                ...comment,
                replies: [...(comment.replies || []), response.data.data],
              }
            : comment
        );
        setComments(updatedComments);
        setReplyingTo(null);
        setReplyText("");
      }
    } catch (error) {
      console.error("Error submitting reply:", error);
    }
  };

  const handleDeletePost = async () => {
    try {
      const response = await axios.post(
        BaseUrl + `deletepost/${post.id}`,
        {},
        {
          headers: {
            Authorization: `Bearer ${Cookies.get("token")}`,
            Accept: "application/json",
          },
        }
      );
      if (response.data.status === 200) {
        setShowOptions(false);
        swal.fire({
          toast: true,
          position: "bottom-start",
          icon: "success",
          title: "Your post has been deleted.",
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
        });
      }
    } catch (error) {
      console.error("Error deleting post:", error);
    }
  };
  useEffect(() => {
    if (!imageModalData) return;
    const handleKeyDown = (e) => {
      switch (e.key) {
        case "ArrowLeft":
          prevImage();
          break;
        case "ArrowRight":
          nextImage();
          break;
        case "Escape":
          closeImageModal();
          break;
        default:
          break;
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [imageModalData, currentImageIndex]);
  const openImageModal = (files, index = 0) => {
    console.log(files);
    setImageModalData(files);
    setCurrentImageIndex(index);
  };

  const closeImageModal = () => {
    setImageModalData(null);
    setCurrentImageIndex(0);
  };

  const nextImage = () => {
    setCurrentImageIndex((prev) => (prev + 1) % imageModalData.length);
  };

  const prevImage = () => {
    setCurrentImageIndex(
      (prev) => (prev - 1 + imageModalData.length) % imageModalData.length
    );
  };

  return (
    <div className="w-full ">
      <div className="">
        <div>
          {post ? (
            <div className="bg-gray-100 h-screen">
              <div className="">
                <div className="border border-gray-200 rounded-lg bg-white shadow-sm hover:shadow-md transition-shadow duration-200">
                  <div className="relative flex items-start justify-between space-x-3 px-4 py-2">
                    <div className="flex items-center space-x-3">
                      <div className="w-10 h-10 rounded-full overflow-hidden">
                        {post.user_profile ? (
                          <img
                            src={post.user_profile}
                            alt={post.user_name}
                            className="w-full h-full object-cover border border-gray-200 rounded-full"
                          />
                        ) : (
                          <div className="w-full h-full bg-blue-500 flex items-center justify-center text-white font-semibold text-lg">
                            {post.user_name?.charAt(0).toUpperCase()}
                          </div>
                        )}
                      </div>
                      <div>
                        <h3 className="font-semibold">{post.user_name}</h3>
                        <p className="text-xs text-gray-500">
                          {formatDate(post.created_at)}
                          <span className="mx-1">•</span>
                          <span>Post</span>
                        </p>
                      </div>
                    </div>

                    <PiDotsThree
                      className="text-2xl cursor-pointer hover:text-gray-700"
                      onClick={() => setShowOptions(!showOptions)}
                      ref={buttonRef}
                    />

                    {showOptions && (
                      <div
                        ref={optionsRef}
                        className="absolute bg-white border border-gray-300 shadow-lg rounded-b-lg rounded-tl-lg  z-50 mt-5 w-56 right-1 overflow-hidden"
                      >
                        <button
                          className="flex items-center gap-3 w-full px-4 py-3 text-gray-800 text-md font-medium hover:bg-gray-100 transition-colors"
                          onClick={handleToggleSave}
                        >
                          {isSaved ? (
                            <FaBookmark className="text-blue-600" />
                          ) : (
                            <FaRegBookmark />
                          )}
                          {isSaved ? "Unsave" : "Save"}
                        </button>
                      </div>
                    )}
                  </div>

                  <p className="text-[15px] px-4 pb-2 text-gray-800 leading-snug whitespace-pre-line">
                    {post.content}
                  </p>

                  <div
                    className={`grid gap-1 overflow-hidden ${
                      post.media.length === 1
                        ? "grid-cols-1 min-h-[250px]"
                        : "grid-cols-2 min-h-[250px]"
                    }`}
                  >
                    {post.media.slice(0, 4).map((image, index) => (
                      <div
                        key={index}
                        className={`relative group cursor-pointer flex justify-center ${
                          post.media.length === 3 && index === 0
                            ? "col-span-2"
                            : ""
                        }`}
                        onClick={() => {
                          openImageModal(post.media, index);
                        }}
                      >
                        <img
                          src={image.url}
                          alt={`preview-${index}`}
                          className="h-full w-full object-cover"
                        />
                        {index === 3 && post.media.length > 4 && (
                          <div className="absolute inset-0 flex items-center justify-center bg-black/40 text-white font-bold text-2xl">
                            +{post.media.length - 4}
                          </div>
                        )}
                      </div>
                    ))}
                  </div>

                  {imageModalData && (
                    <div
                      className="fixed inset-0 bg-black bg-opacity-60 backdrop-blur-sm flex items-center justify-center z-50 animate-fade-in"
                      tabIndex={-1}
                    >
                      <div className="relative bg-white rounded-xl shadow-2xl overflow-hidden w-[1000px] flex flex-col transition-all duration-300">
                        {/* Top Header Section */}
                        <div className="w-full flex justify-end p-4 border-b border-gray-200 bg-white z-10">
                          <button
                            onClick={closeImageModal}
                            className="bg-white hover:bg-gray-100 text-black rounded-full w-10 h-10 flex items-center justify-center shadow-md transition-transform duration-200 hover:scale-110"
                            title="Close"
                          >
                            <i className="fas fa-times text-xl"></i>
                          </button>
                        </div>

                        {/* Fixed Size Image/Video Container */}
                        <div className="relative w-full h-[600px] bg-black flex items-center justify-center">
                          {imageModalData[currentImageIndex].type === "image" ? (
                            <img
                              src={imageModalData[currentImageIndex].url}
                              alt={imageModalData[currentImageIndex].name}
                              className="w-full h-full object-contain"
                            />
                          ) : (
                            <video
                              src={imageModalData[currentImageIndex].url}
                              controls
                              className="w-full h-full object-contain"
                            />
                          )}

                          {/* Navigation Buttons */}
                          {imageModalData.length > 1 && (
                            <>
                              <button
                                onClick={prevImage}
                                className="absolute left-4 top-1/2 transform -translate-y-1/2 bg-white hover:bg-gray-100 text-black rounded-full w-10 h-10 flex items-center justify-center shadow-md transition-transform duration-200 hover:scale-110"
                                title="Previous"
                              >
                                <i className="fas fa-chevron-left text-xl"></i>
                              </button>
                              <button
                                onClick={nextImage}
                                className="absolute right-4 top-1/2 transform -translate-y-1/2 bg-white hover:bg-gray-100 text-black rounded-full w-10 h-10 flex items-center justify-center shadow-md transition-transform duration-200 hover:scale-110"
                                title="Next"
                              >
                                <i className="fas fa-chevron-right text-xl"></i>
                              </button>

                              {/* Counter */}
                              <div className="absolute bottom-3 left-1/2 transform -translate-x-1/2 bg-white px-3 py-1 rounded-full shadow text-sm text-gray-700">
                                {currentImageIndex + 1} /{" "}
                                {imageModalData.length}
                              </div>
                            </>
                          )}
                        </div>
                      </div>
                    </div>
                  )}

                  <div className="flex justify-between items-center px-4 py-2 border-t border-gray-100">
                    <button
                      onClick={handleLike}
                      className="flex items-center space-x-1 text-gray-500 hover:text-blue-500 px-3 py-1.5 rounded-md hover:bg-gray-50"
                    >
                      <i
                        className={`fas fa-thumbs-up ${
                          hasLiked ? "text-blue-600" : ""
                        }`}
                      ></i>
                      <span className="text-sm">{likes}</span>
                    </button>

                    <button
                      onClick={handleShowComments}
                      className="flex items-center space-x-1 text-gray-500 hover:text-blue-500 px-3 py-1.5 rounded-md hover:bg-gray-50"
                    >
                      <i className="far fa-comment"></i>
                      <span className="text-sm">{comments.length}</span>
                    </button>

                    <button className="flex items-center space-x-1 text-gray-500 hover:text-green-500 px-3 py-1.5 rounded-md hover:bg-gray-50">
                      <FaRegShareSquare />
                      <span className="text-sm">Share</span>
                    </button>
                  </div>

                  {showComments && (
                    <div className="px-4 pb-3 bg-gray-50 rounded-b-lg">
                      <form
                        onSubmit={handleCommentSubmit}
                        className="flex items-center gap-2 pt-3"
                      >
                        {CurrentUser.profile_image ? (
                          <img
                            src={CurrentUser.profile_image}
                            alt={CurrentUser.name}
                            className="w-8 h-8 rounded-full object-cover"
                          />
                        ) : (
                          <div className="w-8 h-8 rounded-full bg-purple-500 text-white flex items-center justify-center font-semibold text-sm">
                            {CurrentUser.name?.charAt(0).toUpperCase() || "U"}
                          </div>
                        )}
                        <div className="flex-1 relative">
                          <input
                            ref={commentInputRef}
                            type="text"
                            autoFocus
                            className="w-full p-2 pl-3 pr-10 border border-gray-300 rounded-full focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500 text-sm"
                            placeholder="Write a comment..."
                            value={newComment}
                            onChange={(e) => setNewComment(e.target.value)}
                            onKeyDown={(e) => {
                              if (e.key === "Enter" && !e.shiftKey) {
                                e.preventDefault();
                                handleCommentSubmit(e);
                              }
                            }}
                          />
                          <div className="absolute right-2 top-1/2 transform -translate-y-1/2 flex gap-1">
                            <button
                              type="button"
                              onClick={() =>
                                setShowEmojiPicker(!showEmojiPicker)
                              }
                              className="text-gray-500 hover:text-gray-700"
                            >
                              😊
                            </button>
                            {showEmojiPicker && (
                              <EmojiPickerWrapper
                                onEmojiSelect={(emoji) =>
                                  setNewComment((prev) => prev + emoji)
                                }
                                onClose={() => setShowEmojiPicker(false)}
                                positionClass="bottom-10 right-0"
                                inputRef={commentInputRef}
                              />
                            )}
                            <button
                              type="submit"
                              className="text-blue-500 hover:text-blue-600"
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                className="h-5 w-5"
                                viewBox="0 0 20 20"
                                fill="currentColor"
                              >
                                <path
                                  fillRule="evenodd"
                                  d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-8.707l-3-3a1 1 0 00-1.414 1.414L10.586 9H7a1 1 0 100 2h3.586l-1.293 1.293a1 1 0 101.414 1.414l3-3a1 1 0 000-1.414z"
                                  clipRule="evenodd"
                                />
                              </svg>
                            </button>
                          </div>
                        </div>
                      </form>

                      <div className="mt-3 space-y-3  pr-2">
                        {comments
                          .slice(0, showAllComments ? Infinity : 2)
                          .map((comment) => (
                            <div
                              key={comment.comment_id}
                              className="flex gap-3"
                            >
                              <div className="flex-shrink-0 pt-3">
                                {comment.comment_user_profile ? (
                                  <img
                                    src={comment.comment_user_profile}
                                    alt={comment.comment_user_name}
                                    className="w-8 h-8 rounded-full object-cover border border-gray-200"
                                  />
                                ) : (
                                  <div className="w-8 h-8 rounded-full bg-blue-500 flex items-center justify-center text-white font-semibold text-sm border border-gray-200">
                                    {comment.comment_user_name?.[0]?.toUpperCase()}
                                  </div>
                                )}
                              </div>

                              <div className="flex-1">
                                <div className="bg-gray-50 rounded-2xl p-3">
                                  <div className="flex items-center justify-between">
                                    <div className="flex items-center gap-1">
                                      <p className="font-medium text-sm text-gray-900 hover:underline hover:text-blue-600 cursor-pointer">
                                        {comment.comment_user_name || "User"}
                                      </p>
                                      {comment.is_author && (
                                        <span className="text-xs text-gray-500 bg-gray-100 px-1.5 py-0.5 rounded-full">
                                          Author
                                        </span>
                                      )}
                                    </div>
                                    <span className="text-xs text-gray-500">
                                      {formatTimeAgo(comment.created_at)}
                                    </span>
                                  </div>

                                  <p className="text-sm text-gray-800 mt-1 whitespace-pre-line">
                                    {comment.comment}
                                  </p>

                                  <div className="flex items-center mt-2 text-xs text-gray-500">
                                    <button
                                      className={`flex items-center gap-1 hover:text-blue-600 ${
                                        comment.has_liked_comment
                                          ? "text-blue-600"
                                          : ""
                                      }`}
                                      onClick={() =>
                                        handleCommentLike(
                                          comment.has_liked_comment,
                                          comment.comment_id
                                        )
                                      }
                                    >
                                      <i
                                        className={`fas fa-thumbs-up ${
                                          comment.has_liked_comment
                                            ? "text-blue-500"
                                            : ""
                                        }`}
                                      ></i>
                                      {comment.comment_likes > 0 && (
                                        <span>{comment.comment_likes}</span>
                                      )}
                                      <span>Like</span>
                                    </button>

                                    <span className="mx-2 text-gray-800">
                                      |
                                    </span>

                                    <button
                                      className="flex items-center gap-1 hover:text-blue-600"
                                      onClick={() =>
                                        setReplyingTo(
                                          replyingTo === comment.comment_id
                                            ? null
                                            : comment.comment_id
                                        )
                                      }
                                    >
                                      <MdReply className="text-base" />
                                      <span className="ml-1">Reply</span>
                                      {comment.replies &&
                                        comment.replies.length > 0 && (
                                          <>
                                            <span className="mx-1">•</span>
                                            <span>
                                              {comment.replies.length}
                                            </span>
                                            {comment.replies.length === 1
                                              ? "reply"
                                              : "replies"}
                                          </>
                                        )}
                                    </button>
                                  </div>
                                </div>

                                {comment.replies &&
                                  comment.replies.length > 0 && (
                                    <div className="mt-2 ml-2 pl-4 border-l-2 border-gray-200">
                                      {comment.replies
                                        .slice(
                                          0,
                                          showAllReplies[comment.comment_id]
                                            ? comment.replies.length
                                            : 2
                                        )
                                        .map((reply) => (
                                          <div
                                            key={reply.comment_id}
                                            className="flex gap-3 mt-3"
                                          >
                                            <div className="flex-shrink-0">
                                              {reply.comment_user_profile ? (
                                                <img
                                                  src={
                                                    reply.comment_user_profile
                                                  }
                                                  alt={reply.comment_user_name}
                                                  className="w-8 h-8 rounded-full object-cover border border-gray-200"
                                                />
                                              ) : (
                                                <div className="w-8 h-8 rounded-full bg-blue-500 flex items-center justify-center text-white font-semibold text-sm border border-gray-200">
                                                  {reply.comment_user_name?.[0]?.toUpperCase()}
                                                </div>
                                              )}
                                            </div>

                                            <div className="flex-1">
                                              <div className="bg-gray-50 rounded-2xl p-3">
                                                <div className="flex items-center justify-between">
                                                  <div className="flex items-center gap-1">
                                                    <p className="font-medium text-sm text-gray-900 hover:underline hover:text-blue-600 cursor-pointer">
                                                      {reply.comment_user_name ||
                                                        "User"}
                                                    </p>
                                                    {reply.is_author && (
                                                      <span className="text-xs text-gray-500 bg-gray-100 px-1.5 py-0.5 rounded-full">
                                                        Author
                                                      </span>
                                                    )}
                                                  </div>
                                                  <span className="text-xs text-gray-500">
                                                    {formatTimeAgo(
                                                      reply.created_at
                                                    )}
                                                  </span>
                                                </div>

                                                <p className="text-sm text-gray-800 mt-1">
                                                  {reply.comment}
                                                </p>

                                                <div className="flex items-center mt-2 text-xs text-gray-500 space-x-4">
                                                  <button
                                                    className={`flex items-center gap-1 hover:text-blue-600 ${
                                                      reply.has_liked_comment
                                                        ? "text-blue-600"
                                                        : ""
                                                    }`}
                                                    onClick={() =>
                                                      handleCommentLike(
                                                        reply.has_liked_comment,
                                                        reply.comment_id
                                                      )
                                                    }
                                                  >
                                                    <MdThumbUp className="icon" />
                                                    {reply.comment_likes >
                                                      0 && (
                                                      <span>
                                                        {reply.comment_likes}
                                                      </span>
                                                    )}
                                                    <span>Like</span>
                                                  </button>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        ))}

                                      {comment.replies.length > 2 && (
                                        <button
                                          onClick={() =>
                                            setShowAllReplies((prev) => ({
                                              ...prev,
                                              [comment.comment_id]:
                                                !prev[comment.comment_id],
                                            }))
                                          }
                                          className="w-full text-left text-sm font-medium text-gray-600 hover:text-blue-600 transition-colors mt-2"
                                        >
                                          <div className="inline-flex items-center px-4 py-1.5 rounded-full hover:bg-gray-100">
                                            {showAllReplies[
                                              comment.comment_id
                                            ] ? (
                                              <>
                                                <MdKeyboardArrowUp className="mr-1 text-lg" />
                                                Collapse replies
                                              </>
                                            ) : (
                                              <>
                                                <MdKeyboardArrowDown className="mr-1 text-lg" />
                                                See {comment.replies.length - 2}{" "}
                                                more{" "}
                                                {comment.replies.length - 2 ===
                                                1
                                                  ? "reply"
                                                  : "replies"}
                                              </>
                                            )}
                                          </div>
                                        </button>
                                      )}
                                    </div>
                                  )}

                                {replyingTo === comment.comment_id && (
                                  <div className="mt-3 ml-2 pl-4 border-l-2 border-gray-200">
                                    <form
                                      onSubmit={(e) =>
                                        handleReplySubmit(e, comment.comment_id)
                                      }
                                      className="flex gap-2 items-start"
                                    >
                                      {comment.comment_user_profile ? (
                                        <img
                                          src={comment.comment_user_profile}
                                          alt={comment.comment_user_name}
                                          className="w-8 h-8 rounded-full object-cover border border-gray-200"
                                        />
                                      ) : (
                                        <div className="w-8 h-8 rounded-full bg-blue-500 flex items-center justify-center text-white font-semibold text-sm border border-gray-200">
                                          {comment.comment_user_name?.[0]?.toUpperCase()}
                                        </div>
                                      )}
                                      <div className=" flex-1 flex flex-col">
                                        <div className="relative flex items-center border rounded-full w-full py-2 px-4 text-sm focus-within:ring-1 focus-within:ring-blue-500">
                                          <input
                                            ref={(el) =>
                                              (replyInputRefs.current[
                                                replyingTo
                                              ] = el)
                                            }
                                            type="text"
                                            value={replyText}
                                            onChange={(e) =>
                                              setReplyText(e.target.value)
                                            }
                                            placeholder="Add a comment..."
                                            className="flex-1 outline-none bg-transparent"
                                            onKeyDown={(e) => {
                                              if (
                                                e.key === "Enter" &&
                                                !e.shiftKey
                                              ) {
                                                e.preventDefault();
                                                handleReplySubmit(
                                                  e,
                                                  comment.comment_id
                                                );
                                              }
                                            }}
                                          />
                                          <button
                                            type="button"
                                            onClick={() =>
                                              setShowReplyEmojiPicker(
                                                comment.comment_id
                                              )
                                            }
                                            className="text-gray-500 hover:text-gray-700 ml-2"
                                          >
                                            😊
                                          </button>
                                          {showReplyEmojiPicker ===
                                            comment.comment_id && (
                                            <EmojiPickerWrapper
                                              onEmojiSelect={(emoji) =>
                                                setReplyText(
                                                  (prev) => prev + emoji
                                                )
                                              }
                                              onClose={() =>
                                                setShowReplyEmojiPicker(null)
                                              }
                                              positionClass="bottom-10 right-0"
                                              inputRef={{
                                                current:
                                                  replyInputRefs.current[
                                                    replyingTo
                                                  ],
                                              }}
                                            />
                                          )}
                                        </div>
                                        <div className="flex justify-end mt-2">
                                          <button
                                            type="button"
                                            onClick={() => setReplyingTo(null)}
                                            className="text-gray-600 text-sm px-3 py-1 rounded-md hover:bg-gray-100 mr-2"
                                          >
                                            Cancel
                                          </button>
                                          <button
                                            type="submit"
                                            disabled={!replyText.trim()}
                                            className="bg-blue-600 text-white text-sm px-3 py-1 rounded-md hover:bg-blue-700 disabled:bg-blue-300"
                                          >
                                            Post
                                          </button>
                                        </div>
                                      </div>
                                    </form>
                                  </div>
                                )}
                              </div>
                            </div>
                          ))}
                        {comments.length > 2 && (
                          <div className="pt-2">
                            <button
                              onClick={() =>
                                setShowAllComments(!showAllComments)
                              }
                              className="w-full text-center text-sm font-medium text-gray-600 hover:text-blue-600 transition-colors"
                            >
                              <div className="inline-flex items-center px-4 py-1.5 rounded-full hover:bg-gray-100">
                                {showAllComments ? (
                                  <>
                                    <MdKeyboardArrowUp className="mr-1 text-lg" />
                                    Show fewer comments
                                  </>
                                ) : (
                                  <>
                                    <MdKeyboardArrowDown className="mr-1 text-lg" />
                                    Show {comments.length - 2} more{" "}
                                    {comments.length - 2 === 1
                                      ? "comment"
                                      : "comments"}
                                  </>
                                )}
                              </div>
                            </button>
                          </div>
                        )}
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          ) : (
            <div className="px-4">
              <p className="text-gray-700 font-semibold mb-1">
                You haven’t posted yet
              </p>
              <p className="text-gray-500 text-sm mb-4">
                Posts you share will be displayed here.
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default PostFeed;
